import styled from 'styled-components'

import { Input, Typography } from 'primsell-shared-layer/components'

import { InputContainer, Input as InputInner } from 'primsell-shared-layer/components/atoms/input/input.styles'

import { baseTheme } from 'primsell-shared-layer/styles/theme'
import { FireIcon as AssetFireIcon } from 'primsell-shared-layer/assets/icons'

export const FireIcon = styled(AssetFireIcon)`
  width: 20px;
  height: 20px;
`

export const DescriptionContainer = styled.div`
  max-width: 391px;
  text-align: center;
`

export const DescriptionTypography = styled(Typography)`
  font-size: 16px;
  font-weight: 400;
  line-height: 24px;
  color: ${baseTheme.colors.greyTurquoise};
`

export const FormContainer = styled.div`
  margin-top: 20px;
  position: relative;
`

export const FormInput = styled(Input)`
  width: 200px;

  & ${InputContainer} {
    padding: 0;
  }

  & ${InputInner} {
    text-align: center;
  }
`

export const FlyText = styled(Typography)`
  position: absolute;
  bottom: 12px;
  right: -40px;
  color: ${baseTheme.colors.red};
  font-size: 14px;
  cursor: pointer;
`
